<template>
    <select v-model="model">
        <option value=""
                disabled
        >{{ selectText }}</option>
        <option v-for="item in items"
                :value="item.id"
                v-text="item.text"
        ></option>
        <slot></slot>
    </select>
</template>

<script>
    export default {
        props: {
            items: {
                type: Array,
                default: () => []
            },
            selectText: {
                type: String,
                default: 'Choose your options'
            },
            value: {
                default: null,
                required: false
            }
        },
        computed: {
            model () {
                return this.value
            }
        },
        watch: {
            model () {
                this.$el.removeAttribute('onchange')
                this.$nextTick(this.init)
            }
        },
        methods: {
            init () {
                $(this.$el).material_select()

                const vm = this
                this.$el.onchange = function () {
                    vm.$emit('input', this.value)
                }
            },
        },
        mounted () {
            this.$nextTick(this.init)
        }
    }
</script>



// WEBPACK FOOTER //
// select.vue?20fcc40c